import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'sas-infiny-front';

  // ALWAYS DISPLAY THE PAGE TO THE TOP
  onActivate(event: any) {
    window.scroll(0, 0);
  }
}
